/**
 * This is a dirty hack to convert any type to string
 * @param {*} source
 * @returns {string}
 */
const toString = (source) => {
  // This is a dirty hack to convert Array | Object to string
  if (typeof source === 'object') {
    return JSON.stringify(source)
  }

  return `${source}`
}

export { toString }
